import * as type from './type';
export default {
    [type.SET_PLINE_SCROLLTOP](state, plineScrollTop) {
        state.plineScrollTop = plineScrollTop;
    },
    [type.SET_PLINE_PRODUCT_SCROLLTOP](state, plineProductScrollTop) {
        state.plineProductScrollTop = plineProductScrollTop;
    },
}


// WEBPACK FOOTER //
// ./src/store/product-line/mutations.js